import { render, staticRenderFns } from "./exchange1.vue?vue&type=template&id=41aa093a&scoped=true&"
import script from "./exchange1.vue?vue&type=script&lang=js&"
export * from "./exchange1.vue?vue&type=script&lang=js&"
import style0 from "./exchange1.vue?vue&type=style&index=0&id=41aa093a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa093a",
  null
  
)

export default component.exports